import React from "react";
import clsx from "clsx";
import { Col, Form, Row } from "react-bootstrap";
import { WithContext as ReactTags, SEPARATORS } from "react-tag-input";
import { Tag } from "react-tag-input/types/components/SingleTag";

import { Skeleton } from "components";

import "./tagInput.scss";

const separators = [
	SEPARATORS.TAB,
	SEPARATORS.SPACE,
	SEPARATORS.COMMA,
	SEPARATORS.ENTER,
	SEPARATORS.SEMICOLON,
];

type TagInputProps = {
	tags: Tag[];
	placeholder?: string;
	handleDelete: (i: number) => void;
	handleAddition: (tag: Tag) => void;
	handleInputChange: (value: string) => void;
	inputValue: string;
	inputError?: string | undefined;
	controlId?: string;
	label?: string;
	smLabel?: number;
	smSelect?: number;
	isLoading?: boolean;
	autoFocus?: boolean;
	allowDragDrop?: boolean;
	labelClassName?: string;
	inputWrapperClassName?: string;
};

const TagInput = ({
	tags,
	placeholder,
	handleDelete,
	handleAddition,
	handleInputChange,
	inputValue,
	inputError,
	controlId = "",
	label,
	smLabel = 5,
	smSelect = 7,
	isLoading,
	autoFocus = false,
	allowDragDrop = false,
	labelClassName,
	inputWrapperClassName,
}: TagInputProps) => {
	return (
		<Form.Group as={Row} controlId={controlId}>
			{label && (
				<Form.Label column sm={smLabel} className={labelClassName}>
					{label}
				</Form.Label>
			)}
			<Col
				sm={smSelect}
				className={clsx(inputWrapperClassName, inputError && "error")}
			>
				{isLoading ? (
					<Skeleton variant="rect" />
				) : (
					<>
						<ReactTags
							tags={tags}
							separators={separators}
							handleDelete={handleDelete}
							handleAddition={handleAddition}
							handleInputChange={handleInputChange}
							placeholder={placeholder}
							allowAdditionFromPaste
							allowUnique
							allowDragDrop={allowDragDrop}
							inputFieldPosition="inline"
							inputValue={inputValue}
							id={controlId}
							autoFocus={autoFocus}
						/>
						{inputError && (
							<Form.Control.Feedback type="invalid">
								{inputError}
							</Form.Control.Feedback>
						)}
					</>
				)}
			</Col>
		</Form.Group>
	);
};

export default TagInput;
